module.exports = __webpack_public_path__ + "../resources/images/weatherLargeFlat_sprite-dd818a5ad101c875dabe2e74fe8e77cf.png";